import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const examTypeLocaleModule: LocaleModule = {
  name: "examType",
  messages: { en: en, it: it },
};
